import React, { useState } from 'react';

interface Props {
  className?: string;
  mood?: 'happy' | 'thinking' | 'cheeky';
}

const ArbE: React.FC<Props> = ({ className = '', mood = 'happy' }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <div className="w-full h-full bg-leaf/20 rounded-full flex items-center justify-center overflow-hidden border-2 border-gecko shadow-lg">
        {!imageError ? (
          <img 
            src="/icon-512x512.png" 
            alt="GreenTree Logo with Arb-E" 
            className="w-full h-full object-contain p-2"
            onError={() => setImageError(true)}
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className="text-4xl" title="Arb-E">🐒</span>
        )}
      </div>
    </div>
  );
};

export default ArbE;
